
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/gifts/[...slug]",
      function () {
        return require("private-next-pages/user/gifts/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/gifts/[...slug]"])
      });
    }
  